import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SplashPage() {
  const navigate = useNavigate();
  useEffect(() => { const t = setTimeout(() => navigate('/login'), 2000); return () => clearTimeout(t); }, [navigate]);
  return (
    <div className="min-h-[100vh] bg-cover bg-center bg-[url('/images/download_beijing.jpg')]">
      <div className="mx-auto flex min-h-[100vh] max-w-md flex-col items-center justify-center px-8 text-center">
        <img src="/images/logo.png" alt="logo" className="h-24 w-24" />
        <div className="mt-4 text-3xl font-bold text-white drop-shadow">海南计划</div>
        <div className="text-sm tracking-widest text-white/90 drop-shadow">YUNSHUPIAOFANG</div>
      </div>
    </div>
  );
}